import { _keys, Module } from '@nu-art/ts-common';
import { StorageKey } from './ModuleFE_LocalStorage.js';
export class ModuleFE_BaseTheme extends Module {
    options;
    constructor(options) {
        super();
        this.options = options;
    }
    init() {
        _keys(this.options).forEach((option) => {
            return this.setThemeProp(option, this.getThemeProp(option));
        });
    }
    getOptions = () => this.options;
    setThemeProp(themeKey, themeValue) {
        const _themeKey = themeKey;
        document.querySelector('body')?.setAttribute(_themeKey, themeValue);
        this.createStorageKey(themeKey).set(themeValue);
    }
    getThemeProp(themeKey) {
        return this.createStorageKey(themeKey).get(this.options[themeKey][0]);
    }
    createStorageKey(themeKey) {
        const _themeKey = themeKey;
        return new StorageKey(`theme-key--${_themeKey}`);
    }
}
//# sourceMappingURL=ModuleFE_BaseTheme.js.map